import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getPriceUploadHistoriesCount } from '../../apis/partnerBulk';
import { isValidPositiveNumber } from './priceUploadQueryUtils';

export const usePriceUploadHistoriesCount = (partnerId: number) => {
  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['priceUploadHistoriesCount', partnerId],
    enabled: isValidPositiveNumber(partnerId),
    queryFn: () => {
      return getPriceUploadHistoriesCount(partnerId);
    },
  };
  return useQuery(queryOptions);
};
